;(() => {
  // =========================
  // CONFIG (pas dit aan)
  // =========================
  const CFG = {
    brand: "Hefonderdelen.nl",
    title: "Hulp nodig?",
    subtitle: "Kies hoe je contact wilt opnemen",
    primary: "#0A3EC4",
    accent: "#0B5FFF",
    whatsappNumber: "31610592257",
    whatsappMessage: "Hoi, ik heb een vraag over een onderdeel op Hefonderdelen.nl:",
    emailTo: "martijn@vebrion.nl",
    emailSubject: "Vraag via Hefonderdelen.nl",
    showOnMobile: true,
    position: { bottom: 20, right: 20 }
  };

  // Stop als mobiel uit staat
  const isMobile = window.matchMedia && window.matchMedia("(max-width: 640px)").matches;
  if (!CFG.showOnMobile && isMobile) return;

  // Voorkom dubbele inject
  if (window.__hfChatWidgetMounted) return;
  window.__hfChatWidgetMounted = true;

  // =========================
  // Helpers
  // =========================
  const escapeHtml = (s) =>
    String(s).replace(/[&<>"']/g, (c) => ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#039;" }[c]));

  const makeWhatsAppLink = () => {
    const text = encodeURIComponent(CFG.whatsappMessage);
    return `https://wa.me/${CFG.whatsappNumber}?text=${text}`;
  };

  const makeMailToLink = () => {
    const subject = encodeURIComponent(CFG.emailSubject);
    const body = encodeURIComponent(
      `Hoi ${CFG.brand},\n\nMijn vraag:\n\n`
    );
    return `mailto:${CFG.emailTo}?subject=${subject}&body=${body}`;
  };

  // =========================
  // Styles
  // =========================
  const style = document.createElement("style");
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');

    .hf-chat-root { 
      position: fixed !important;
      z-index: 2147483646 !important;
      right: ${CFG.position.right}px !important;
      bottom: ${CFG.position.bottom}px !important;
      left: auto !important;
      top: auto !important;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    }

    .hf-chat-btn {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, ${CFG.primary} 0%, ${CFG.accent} 100%);
      color: #fff;
      cursor: pointer;
      user-select: none;
      box-shadow: 0 8px 28px rgba(10, 62, 196, 0.35);
      border: none;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
    }

    .hf-chat-btn::before {
      content: '';
      position: absolute;
      inset: 0;
      background: radial-gradient(circle at center, rgba(255,255,255,0.2) 0%, transparent 70%);
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .hf-chat-btn:hover {
      transform: translateY(-3px) scale(1.05);
      box-shadow: 0 12px 40px rgba(10, 62, 196, 0.45);
    }

    .hf-chat-btn:hover::before {
      opacity: 1;
    }

    .hf-chat-btn:active {
      transform: translateY(-1px) scale(1.02);
    }

    .hf-chat-btn svg {
      width: 28px;
      height: 28px;
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.1));
    }

    .hf-chat-panel {
      width: 320px;
      max-width: calc(100vw - 32px);
      border-radius: 18px;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18), 0 0 1px rgba(0, 0, 0, 0.1);
      margin-bottom: 12px;
      transform-origin: bottom right;
      transform: scale(0.95) translateY(10px);
      opacity: 0;
      pointer-events: none;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .hf-chat-panel.is-open {
      opacity: 1;
      transform: scale(1) translateY(0);
      pointer-events: auto;
    }

    .hf-chat-header {
      padding: 18px 16px 16px;
      background: linear-gradient(135deg, ${CFG.primary} 0%, ${CFG.accent} 100%);
      color: #fff;
      position: relative;
    }

    .hf-chat-brand {
      font-size: 11px;
      font-weight: 500;
      opacity: 0.9;
      letter-spacing: 0.3px;
      text-transform: uppercase;
    }

    .hf-chat-title {
      font-size: 19px;
      font-weight: 700;
      margin-top: 4px;
      letter-spacing: -0.3px;
    }

    .hf-chat-sub {
      font-size: 13px;
      opacity: 0.95;
      margin-top: 4px;
      line-height: 1.4;
      font-weight: 400;
    }

    .hf-chat-close {
      position: absolute;
      right: 14px;
      top: 14px;
      width: 32px;
      height: 32px;
      border-radius: 10px;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.25);
      color: #fff;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.2s ease;
    }

    .hf-chat-close:hover {
      background: rgba(255, 255, 255, 0.25);
      transform: translateY(-1px);
    }

    .hf-chat-close:active {
      transform: scale(0.95);
    }

    .hf-chat-close svg {
      width: 18px;
      height: 18px;
    }

    .hf-chat-body {
      padding: 16px;
      background: #fff;
    }

    .hf-chat-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .hf-chat-action {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 13px 14px;
      border-radius: 14px;
      border: 1.5px solid #e5e7eb;
      background: #fff;
      color: #111827;
      text-decoration: none;
      font-weight: 600;
      font-size: 14px;
      transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
    }

    .hf-chat-action::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(10, 62, 196, 0.04) 0%, rgba(11, 95, 255, 0.04) 100%);
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    .hf-chat-action:hover {
      transform: translateY(-2px);
      border-color: ${CFG.primary};
      box-shadow: 0 8px 24px rgba(10, 62, 196, 0.12);
    }

    .hf-chat-action:hover::before {
      opacity: 1;
    }

    .hf-chat-action:active {
      transform: translateY(0);
    }

    .hf-chat-badge {
      width: 38px;
      height: 38px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      position: relative;
      z-index: 1;
    }

    .hf-chat-badge.whatsapp {
      background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
    }

    .hf-chat-badge.email {
      background: linear-gradient(135deg, ${CFG.primary} 0%, ${CFG.accent} 100%);
    }

    .hf-chat-badge svg {
      width: 20px;
      height: 20px;
      color: #fff;
      filter: drop-shadow(0 1px 2px rgba(0,0,0,0.1));
    }

    .hf-chat-label {
      position: relative;
      z-index: 1;
    }

    @media (max-width: 640px) {
      .hf-chat-root {
        right: 14px;
        bottom: 14px;
      }

      .hf-chat-panel {
        width: calc(100vw - 28px);
        max-width: 280px;
      }

      .hf-chat-btn {
        width: 52px;
        height: 52px;
      }

      .hf-chat-btn svg {
        width: 22px;
        height: 22px;
      }

      .hf-chat-header {
        padding: 16px 14px 14px;
      }

      .hf-chat-body {
        padding: 14px;
      }

      .hf-chat-action {
        padding: 12px 12px;
        gap: 10px;
      }

      .hf-chat-badge {
        width: 36px;
        height: 36px;
      }

      .hf-chat-badge svg {
        width: 18px;
        height: 18px;
      }
    }
  `;
  document.head.appendChild(style);

  // =========================
  // Markup
  // =========================
  const root = document.createElement("div");
  root.className = "hf-chat-root";

  const panel = document.createElement("div");
  panel.className = "hf-chat-panel";
  panel.innerHTML = `
    <div class="hf-chat-header">
      <div class="hf-chat-brand">${escapeHtml(CFG.brand)}</div>
      <div class="hf-chat-title">${escapeHtml(CFG.title)}</div>
      <div class="hf-chat-sub">${escapeHtml(CFG.subtitle)}</div>
      <button class="hf-chat-close" type="button" aria-label="Sluiten">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="hf-chat-body">
      <div class="hf-chat-actions">
        <a class="hf-chat-action" href="${makeWhatsAppLink()}" target="_blank" rel="noopener">
          <span class="hf-chat-badge whatsapp">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
            </svg>
          </span>
          <span class="hf-chat-label">WhatsApp</span>
        </a>

        <a class="hf-chat-action" href="${makeMailToLink()}">
          <span class="hf-chat-badge email">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </span>
          <span class="hf-chat-label">E-mail</span>
        </a>
      </div>
    </div>
  `;

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "hf-chat-btn";
  btn.setAttribute("aria-label", "Open chat opties");
  btn.innerHTML = `
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"/>
    </svg>
  `;

  root.appendChild(panel);
  root.appendChild(btn);
  document.body.appendChild(root);

  // =========================
  // Behavior (open/close)
  // =========================
  const open = () => {
    panel.classList.add("is-open");
    try {
      localStorage.setItem("hf_chat_open", "1");
    } catch (e) {}
  };

  const close = () => {
    panel.classList.remove("is-open");
    try {
      localStorage.setItem("hf_chat_open", "0");
    } catch (e) {}
  };

  const toggle = () => (panel.classList.contains("is-open") ? close() : open());

  btn.addEventListener("click", toggle);
  panel.querySelector(".hf-chat-close").addEventListener("click", close);

  // Klik buiten panel sluit
  document.addEventListener("click", (e) => {
    const clickedInside = root.contains(e.target);
    if (!clickedInside && panel.classList.contains("is-open")) {
      close();
    }
  });

  // ESC sluit
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && panel.classList.contains("is-open")) {
      close();
    }
  });

  // Optioneel: onthoud laatste state
  try {
    const last = localStorage.getItem("hf_chat_open");
    if (last === "1") {
      setTimeout(open, 100);
    }
  } catch (e) {}
})();